import * as React from 'react';
import { memo, SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#50AF95" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6277 12.5257C13.5368 12.5322 13.0671 12.5588 12.0193 12.5588C11.1859 12.5588 10.5943 12.5351 10.3867 12.5257C7.16606 12.3911 4.76216 11.8586 4.76216 11.2209C4.76216 10.5833 7.16606 10.0515 10.3867 9.91472V11.9953C10.5973 12.0097 11.2003 12.0435 12.0337 12.0435C13.0338 12.0435 13.5345 12.004 13.6247 11.996V9.91616C16.8385 10.0522 19.2371 10.5847 19.2371 11.2209C19.2371 11.8571 16.8392 12.3897 13.6247 12.525L13.6277 12.5257ZM13.6277 9.70097V7.83915H18.1128V5H5.90161V7.83915H10.3859V9.70025C6.74104 9.8593 4 10.5452 4 11.367C4 12.1889 6.74104 12.8741 10.3859 13.0338V19H13.627V13.0317C17.2635 12.8726 20 12.1875 20 11.3663C20 10.5452 17.2658 9.86002 13.627 9.70025L13.6277 9.70097Z"
      fill="white"
    />
  </svg>
);

const Memo = memo(SvgComponent);
export default Memo;
